import { t } from 'i18next'

import { Badge } from '~/components/UI/Badge'
import { getRetailMediaAccountType } from '~/helpers'

import ToogleActiveCampaignKeyword from '../../../ToogleActiveCampaignKeyword'

const renderSwitch = {
  active: {
    title: '',
    render: (rowData: CampaignKeyword) => (
      <ToogleActiveCampaignKeyword data={rowData} key={rowData.id} />
    ),
    width: 50
  }
}

export const schemaKeywords = (): TableSchema<CampaignKeyword> => {
  const accountType = getRetailMediaAccountType()

  return {
    ...(accountType === 'advertiser' ? { ...renderSwitch } : {}),
    title: {
      title: t('rm:keywords'),
      render: rowData => {
        const isPaused = accountType === 'publisher' && !!rowData.disabled_at

        return (
          <>
            <span
              style={
                isPaused ? { color: 'var(--sl-fg-base-disabled)' } : undefined
              }
            >
              {rowData.keyword}
            </span>
            {isPaused && (
              <>
                {' '}
                <Badge template="warning">
                  {t('c:capitalize', {
                    value: t('rm:paused', { context: 'female' })
                  })}
                </Badge>
              </>
            )}
          </>
        )
      },
      className: 'order__details col__infos col__title',
      showTotal: true
    }
  }
}
